import { Button, Description, SubTitle } from "Components/CustomComponents";
import { useNavigate } from "react-router-dom";
import ContentContainer from "Components/Container/ContentContainer";
import styles from "../styles/History.module.scss";
import { WEB_ROUTES } from "../../../constants";
import { Routes, RouteWithDriver } from "Data/interfaces";

interface DriverRouteProps {
  route?: RouteWithDriver | Routes;
  pending?: boolean;
}

const CurrentDriverRoute: React.FC<DriverRouteProps> = ({
  route,
  pending = false,
}) => {
  const navigate = useNavigate();
  // console.log(route);

  return (
    <ContentContainer
      bg="#F5F5F5"
      classes={`d-flex p-2 px-4 flex-wrap justify-content-center justify-content-sm-between align-items-center`}
      hasBoxShadow={false}
    >
      <div className="lc-2" style={{ width: "100px" }}>
        <SubTitle text={route?.route_name} />
      </div>

      <div className="d-flex flex-wrap justify-content-center gap-2">
        <ContentContainer
          bg="#d9d9d933"
          classes="p-2 px-3"
          style={{ width: "fit-content" }}
        >
          <SubTitle
            text={route?.total_stops as unknown as string}
            classes="mb-1"
          />
          <p className="fs-6 fw-light gray-text m-0">Total Stops</p>
        </ContentContainer>
        <ContentContainer
          bg="#d9d9d933"
          classes="p-2 px-3"
          style={{ width: "fit-content" }}
        >
          <SubTitle
            text={route?.remaining_stops as unknown as string}
            classes="mb-1"
          />
          <p className="fs-6 fw-light gray-text m-0">Remaining Stops</p>
        </ContentContainer>
      </div>
      {!pending && route && "drivers" in route && route.drivers ? (
        <div className="d-flex align-items-center gap-2 ">
          <div className="d-flex flex-column">
            <p className="m-0 fs-8">Current Driver</p>
            <div className="d-flex flex-wrap align-items-center gap-3">
              {route.drivers.slice(0, 2).map((driver, index) => (
                <div className="d-flex gap-2 mb-0" key={index}>
                  <img alt="" src={driver.image_url} className={styles.image} />
                  <div className={`d-flex flex-column`}>
                    <SubTitle
                      text={`${driver.firstname} ${driver.lastname}`}
                      classes="mb-05 lc-1"
                    />
                    <Description
                      text={
                        <>
                          Truck No:
                          <span className="fw-bold ms-2">
                            {driver.truck_no}
                          </span>
                        </>
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Button
            text="Activity Logs"
            isOutlined={true}
            classes={` fs-7`}
            onClick={() => navigate(WEB_ROUTES.ROUTE_TRACKING(route.id))}
          />
        </div>
      ) : null}
    </ContentContainer>
  );
};

export default CurrentDriverRoute;
